module.exports = __webpack_public_path__ + "static/SeeVita-04-4b45a452ce1f8818bdde9e7b4a33379d.png";